import { render, staticRenderFns } from "./subcontractingProfession.vue?vue&type=template&id=48328c70&scoped=true&"
import script from "./subcontractingProfession.vue?vue&type=script&lang=js&"
export * from "./subcontractingProfession.vue?vue&type=script&lang=js&"
import style0 from "./subcontractingProfession.vue?vue&type=style&index=0&id=48328c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48328c70",
  null
  
)

export default component.exports